import { Stack } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { TApp } from '@verifime/utils';
import { BackendFeatureToggleList } from './BackendFeatureToggleList';
import { FrontendFeatureToggleList } from './FrontendFeatureToggleList';

export const FeatureToggleList = ({ app }: Readonly<{ app: TApp }>) => {
  return (
    <Stack gap={tokens.spacingBase}>
      <FrontendFeatureToggleList app={app} />
      <BackendFeatureToggleList />
    </Stack>
  );
};
